import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const GastroenterologyIcon: React.FC<IconProps> = ({ size = 16, className = '' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="2" y="2" width="12" height="12" rx="2" stroke="#666666" strokeWidth="1.5" fill="none" />
      <path
        d="M8 5V11M5 8H11"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="8" cy="8" r="0.8" fill="#666666" />
    </svg>
  );
};
